const getResultErrorMessage = (errorResult) => {
    const faults = errorResult?.faults || [];
    return faults[0] ? faults[0].message : undefined;
};
export const ErrorUtils = {
    getResultErrorMessage,
};
